import css from './BarTimer.module.scss'
import React from 'react'

interface Props {
  initialTime: number
  currentTime: number
}

const BarTimer: React.FC<Props> = (props) => {
  const { initialTime, currentTime } = props

  return (
    <div className={css.wrapper}>
      <div className={css.text}>{currentTime} sec.</div>

      <div className={css.bar}>
        <div className={css.regress} style={{ height: '100%', width: `${(currentTime / initialTime) * 100}%` }} />
      </div>
    </div>
  )
}

export default BarTimer
